// src/utils/vueLsWrapper.js
import Vue from 'vue';
import axios from 'axios';
import store from '@/store/store';
import {enableErrorNotification, isDev} from "@/vendor/qconstants";
import {ebus} from "@/vendor/ebus";
import {getGlobalValueOrZero, setGlobalKeyValue} from "@/util/globalState";

// let swBus = null;
let errorBus = null;

export function init() {
  console.log('init globalErrorHandler');
  try {
    // let swBus = new BroadcastChannel('swBus');
    errorBus = new BroadcastChannel('errorBus');
    errorBus.onmessage = (e) => {
      let d = e.data;
      if (d) {
        console.log('errorBus message received in sw: ' + JSON.stringify(d));
        errorReport(e.data);
      }
    };
  } catch (e) {

  }
}

export function errorToString(error) {
  try {
    if (error instanceof Error) {
      return JSON.stringify({
        message: error.message,
        stack: error.stack,
        name: error.name,
        location: extractErrorLocation(error.stack),
      }, null, 2);
    }
    return String(error);
  } catch (e) {
    return "errorToString " + error;
  }
}

// function broadcastError(details) {
//   try {
//     let broadcastMsg = {
//       eReport: true,
//       err: details,
//     };
//     errorBus.postMessage(broadcastMsg);
//   } catch (e) {
//
//   }
// }

function logErrorToService(errMsg, details) {
  let detailedErr = errMsg + ' ' + details;
  console.error(detailedErr);

  if (isDev) {
    // doSendErrorReport('DEV: ' + detailedErr);
  } else {
    doSendErrorReport(detailedErr);
  }

  if (enableErrorNotification) {
    if (errMsg === details) {
      details = '';
    }
    ebus.$emit('showInfo', {
      title: 'Error: ' + errMsg,
      text: details,
    });
  }
  // else {
  // ebus.$emit('throwError', getErrorDetails(detailedErr);
  // }
}

function componentToString(vm) {
  try {
    const name = vm.$options.name || vm.$options._componentTag;
    // const propsData = vm.$props;
    // const data = vm.$data;
    // const computed = Object.keys(vm.$options.computed || {}).reduce((result, key) => {
    //   result[key] = vm[key];
    //   return result;
    // }, {});
    // const methods = Object.keys(vm.$options.methods || {});

    return JSON.stringify({name}, null, 2);
    // return JSON.stringify({name, propsData, data, computed, methods}, null, 2);
  } catch (error) {
    return vm;
    // return 'Error serializing component instance';
  }
}

function extractErrorLocation(stack) {
  if (stack) {
    const match = stack.match(/\((.*):(\d+):(\d+)\)/);
    if (match) {
      return {
        file: match[1],
        line: match[2],
        column: match[3]
      };
    }
  }
  return null;
}

export function getErrorDetails(error, component, info) {
  // let imo = localStorage.getItem('imo_') || Vue.ls.get('imo') || store.getters.imo;
  let page = localStorage.getItem('page_') || store.getters.page;
  let storageIsPersistent = '' + localStorage.getItem("storageIsPersistent");

  let details = '';
  if (info) {
    let truncated = info.slice(0, 100);
    details += ' info:' + truncated + ' ';
  }

  details += errorToString(error);
  details += ' on IMO: ' + imo;
  details += ' on page: ' + page + ' ';
  details += ' storageIsPersistent: ' + storageIsPersistent;

  if (error && error instanceof DOMException) {
    const location = extractErrorLocation(error.stack);
    if (location) {
      details += ' location:' + `${location.file}:${location.line}:${location.column}`;
    } else {
      details += ' location: not detectable by error.stack';
    }
  } else {
    try {
      details += ' location: not detectable by type';
    } catch (e) {
    }
  }

  if (component) {
    details += ' component:' + componentToString(component);
  }
  return details;
}

function getErrorMessage(error) {
  let errMsg = (typeof error === 'string') ? error : error.message;
  if (isQuotaError(error)) {
    errMsg = 'QuotaExceededError: Local storage limit exceeded.';
  }
  return errMsg;
}

export const lsWrapper = {
  set(key, value, expire) {
    try {
      return Vue.ls.set(key, value, expire);
    } catch (error) {
      errorReport(error);
    }
  },
  get(key, defaultValue = null) {
    try {
      return Vue.ls.get(key, defaultValue);
    } catch (error) {
      errorReport(error);
    }
  },
  remove(key) {
    try {
      return Vue.ls.remove(key);
    } catch (error) {
      errorReport(error);
    }
  },
  clear() {
    try {
      return Vue.ls.clear();
    } catch (error) {
      errorReport(error);
    }
  },
};

async function doSendErrorReport(m) {
  try {
    // let fd = 'no data';
    // let ci = 'no cartItems';
    // try {
    //   if (typeof localStorage !== 'undefined') {
    //     fd = localStorage.getItem('formData');
    //     ci = localStorage.getItem('cartItems');
    //   }
    // } catch (e) {
    // }

    let postBody = JSON.stringify({
      appVersion: window.appVersion,
      error: m,
      agent: navigator.userAgent || navigator.vendor || window.opera || '',
      // formData: fd,
      // cartItems: ci,
    });

    console.log('doSendErrorReport now...');
    axios.post('/errors/report', postBody, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        // Handle successful response
        console.log('doSendErrorReport succeeded');
      })
      .catch(error => {
        // Handle error
        console.log('doSendErrorReport failed');
      });
  } catch (e) {

  }
}

function handleQuota(errMsg, details) {
  // ebus.$emit('showInfo', {
  //   title: 'Error: ' + errMsg + '. Please use "CLEAR CACHE" on the page General > Sitemap',
  //   text: details,
  // });

  //FIXME
  // triggerSwDestroy();

  // try {
  //   let broadcastMsg = {
  //     forwardEmit: true,
  //     address: 'showInfo',
  //     params: {
  //       title: 'Error: ' + errMsg + '. Please use "CLEAR CACHE" on the page General > Sitemap',
  //       text: details,
  //     },
  //   };
  //   swBus.postMessage(broadcastMsg);
  // } catch (e) {
  // }
}

function isQuotaError(error) {
  if (error && error instanceof DOMException) {
    if (error.code === 22) {
      return true;
    }
  }
  return false;
}

export function triggerSwDestroy() {
  try {
    console.log('triggerSwDestroy...');
    navigator.serviceWorker.controller.postMessage({
      type: 'selfDestroy',
    });
  } catch (e) {

  }
}

export function errorReport(error, component, info) {
  try {
    if (!error && !component && !info) {
      return;
    }
    // let combi = error + component + info;
    // console.log('errorReport: ' + error + component + info);
    //
    // if (combi === 'TypeError: Cannot read properties of undefined (reading \'details\')[object Object]v-on handler (Promise/async)') {
    //   return; //FIXME
    // }

    let now = Date.now();
    let easer = getGlobalValueOrZero('loadEaserErrorReport');
    if (!easer || now - parseInt(easer) > 30 * 1000) {
      setGlobalKeyValue('loadEaserErrorReport', now);
    } else {
      //eased
      console.log('eased error ' + error);
      return;
    }

    let errMsg = getErrorMessage(error);
    let details = getErrorDetails(error, component, info);

    if (isQuotaError(error)) {
      handleQuota(errMsg, details);
    }

    logErrorToService(errMsg, details);

  } catch (e) {

  }
}
